import { FileText, ClipboardList, BrainCircuit, Users, Package } from 'lucide-react';
import GeneralInfoTab from './Tabs/GeneralInfoTab';
import ProductDetailsTab from './Tabs/ProductDetailsTab';
import TeamAndRolesTab from './Tabs/TeamAndRolesTab';
import FilesAndDocsTab from './Tabs/FilesAndDocsTab';
import AiPromptTab from './Tabs/AiPromptTab';

export const NEW_JOB_TABS_CONFIG = [
  { id: 'general', label: 'Información General', icon: Package, component: GeneralInfoTab },
  { id: 'details', label: 'Detalles del Trabajo', icon: ClipboardList, component: ProductDetailsTab },
  // La pestaña "Checklist y Tareas" ha sido eliminada de esta configuración.
  { id: 'team', label: 'Equipo y Roles', icon: Users, component: TeamAndRolesTab },
  { id: 'files', label: 'Archivos y Documentos', icon: FileText, component: FilesAndDocsTab },
  { id: 'ai', label: 'Asistente IA', icon: BrainCircuit, component: AiPromptTab },
];

